export default {
  viewAll: 'Voir tout',
  clearHistory: 'Effacer l\'historique',
  noGamesAvailable: 'Aucun jeu disponible',
  showMore: 'Voir plus',
  showLess: 'Voir moins',
  loading: 'Chargement...',
  error: 'Erreur',
  retry: 'Réessayer',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  save: 'Enregistrer',
  delete: 'Supprimer',
  edit: 'Modifier',
  close: 'Fermer',
  submit: 'Soumettre',
  back: 'Retour',
  next: 'Suivant',
  searchPlaceholder: 'Rechercher des jeux...',
  search: 'Rechercher',
  noMoreGames: 'Plus de jeux',
  backToTop: 'Retour en haut'
}; 